import { IBondGelemReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_DELTA_LINKED';

export type IReportDeltaLinkedItem = IBondGelemReport & { __isSelected: boolean };
